import React, { useState } from 'react';
import { StanModal } from '@/components/core-components/StanModal/StanModal';
import { StanButton } from '@/components/core-components/StanButton/StanButton';
import { useCashout } from '../hooks/useCashout';
import { CashOutCelebrationModal } from './CashOutCelebrationModal';
import StripeLogo from '@/assets/icons/payments/stripe.svg';

interface CashOutModalProps {
    isOpen: boolean;
    onClose: () => void;
    payoutSchedule?: number;
    onCashoutSuccess?: () => void;
}

export const CashOutModal: React.FC<CashOutModalProps> = ({ isOpen, onClose, payoutSchedule, onCashoutSuccess }) => {
    const [showCelebration, setShowCelebration] = useState(false);
    const [celebrationAmount, setCelebrationAmount] = useState(0);
    const [celebrationCurrency, setCelebrationCurrency] = useState('USD');

    const handleCashoutSuccess = (amount: number, currency: string) => {
        setCelebrationAmount(amount);
        setCelebrationCurrency(currency);
        setShowCelebration(true);
        onCashoutSuccess?.();
    };

    const {
        cashout,
        isProcessing,
        hasPendingBalance,
        pendingBalance,
        holdTimeEstimate,
        cashoutBalance,
        depositString,
        hasAvailableBalance,
    } = useCashout({
        onClose,
        onSuccess: handleCashoutSuccess,
        payoutSchedule,
    });

    return (
        <>
            <StanModal id='cashout-modal' isOpen={isOpen} onClose={onClose} title='Cash Out' size='sm'>
                <div className='text-center'>
                    {hasPendingBalance && (
                        <p className='text-gray mb-4 flex items-center gap-2 text-sm'>
                            <img src={StripeLogo} alt='Stripe' className='inline-block h-4 flex-shrink-0' />
                            is still processing {pendingBalance} of your funds.
                            <br />
                            {holdTimeEstimate}
                        </p>
                    )}

                    <div className='pt-4 pb-12'>
                        <h1 className='text-dark pb-3 font-bold'>{cashoutBalance}</h1>
                        <p className='text-light text-sm'>{depositString}</p>
                    </div>

                    {hasAvailableBalance && (
                        <StanButton
                            name='cashout-button'
                            className='w-full'
                            size='lg'
                            loading={isProcessing}
                            disabled={isProcessing}
                            onClick={() => {
                                cashout();
                            }}
                        >
                            Cash Out
                        </StanButton>
                    )}
                </div>
            </StanModal>

            <CashOutCelebrationModal
                isOpen={showCelebration}
                amount={celebrationAmount}
                currency={celebrationCurrency}
                onClose={() => setShowCelebration(false)}
            />
        </>
    );
};
